var map = {
	"./1.jpg": 98,
	"./10.jpg": 624,
	"./11.jpg": 141,
	"./12.jpg": 538,
	"./13.jpg": 375,
	"./14.jpg": 180,
	"./15.jpg": 225,
	"./16.jpg": 142,
	"./17.jpg": 627,
	"./18.jpg": 280,
	"./2.jpg": 173,
	"./3.jpg": 856,
	"./4.jpg": 595,
	"./5.jpg": 550,
	"./6.jpg": 817,
	"./7.jpg": 940,
	"./8.jpg": 39,
	"./9.jpg": 978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;